import React, { Component } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

import {
  triggerCalculations,
  updateCalculationDisplayMhz
} from '../../../../actions';
import styles from '../../../../constants/styles';
import {
  getImpedanceModelings,
  getImpedanceDisplayMhz,
  getAvailableImpedanceMhzs,
  getCharacteristicImpedanceChartData,
  getDifferentialImpedanceChartData,
  getPropagationDelayChartData,
  getLengthUnit,
} from '../../../../reducers';
import ImpedanceModelingsTable from './ImpedanceModelingsTable';
import ImpedanceCharts, { chartDataPropTypes } from './ImpedanceCharts';
import SimulationModelModal from './SimulationModelModal';

import { impedanceModelingPropType } from './propTypes';

export class ResultViewer extends Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
      modalData: null
    }
    this.handleMhzUpdate = this.handleMhzUpdate.bind(this);
    this.openSimulationModelModal = this.openSimulationModelModal.bind(this);
    this.closeSimulationModelModal = this.closeSimulationModelModal.bind(this);
  }

  handleMhzUpdate(event) {
    const { updateCalculationDisplayMhz } = this.props;
    updateCalculationDisplayMhz(event.target.value);
  }

  openSimulationModelModal(impedanceModeling) {
    const that = this;
    return function() {
      that.setState({
        modalOpen: true,
        modalData: impedanceModeling
      });
    }
  }

  closeSimulationModelModal() {
    this.setState({
      modalOpen: false
    });
  }

  render() {
    const {
      classes,
      availableMhzs,
      displayMhz,
      impedanceModelings,
      characteristicImpedanceChartData: characteristicImpedance,
      differentialImpedanceChartData: differentialImpedance,
      propagationDelayChartData: propagationalDelay,
      triggerCalculations,
      location,
      lengthUnit,
      print
    } = this.props;

    const { pathname } = location;
    const { modalOpen, modalData } = this.state;
    return (
      <Paper className={classes.paper}>
        <ImpedanceModelingsTable
          availableMhzs={availableMhzs}
          displayMhz={displayMhz}
          impedanceModelings={impedanceModelings}
          refresh={triggerCalculations}
          onMhzUpdate={this.handleMhzUpdate}
          onSimulationModelClick={this.openSimulationModelModal}
          currentPath={pathname}
          lengthUnit={lengthUnit}
          print={print}
        />
        <SimulationModelModal
          open={modalOpen}
          data={modalData}
          lengthUnit={lengthUnit}
          onClose={this.closeSimulationModelModal}
        />
        {!print && (
          <ImpedanceCharts
            characteristicImpedance={characteristicImpedance}
            differentialImpedance={differentialImpedance}
            propagationalDelay={propagationalDelay}
          />
        )}
      </Paper>
    );
  }
}

const mapDispatchToProps = {
  triggerCalculations,
  updateCalculationDisplayMhz
}

function mapStateToProps(state){
  const impedanceModelings = getImpedanceModelings(state);
  const characteristicImpedanceChartData = getCharacteristicImpedanceChartData(state);
  const differentialImpedanceChartData = getDifferentialImpedanceChartData(state);
  const propagationDelayChartData = getPropagationDelayChartData(state);
  const availableMhzs = getAvailableImpedanceMhzs(state);
  const displayMhz = getImpedanceDisplayMhz(state);
  const lengthUnit = getLengthUnit(state);
  return {
    characteristicImpedanceChartData,
    differentialImpedanceChartData,
    propagationDelayChartData,
    impedanceModelings,
    availableMhzs,
    displayMhz,
    lengthUnit
  }
}

ResultViewer.propTypes = {
  classes:                          PropTypes.objectOf(PropTypes.string).isRequired,
  impedanceModelings:               PropTypes.arrayOf(impedanceModelingPropType).isRequired,
  characteristicImpedanceChartData: PropTypes.shape(chartDataPropTypes).isRequired,
  differentialImpedanceChartData:   PropTypes.shape(chartDataPropTypes).isRequired,
  propagationDelayChartData:        PropTypes.shape(chartDataPropTypes).isRequired,
  availableMhzs:                    PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCalculationDisplayMhz:      PropTypes.func.isRequired,
  triggerCalculations:              PropTypes.func.isRequired,
  displayMhz:                       PropTypes.number,
  lengthUnit:                       PropTypes.string.isRequired,

  // props from withRouter
  location:                         ReactRouterPropTypes.location.isRequired,

  // user props;
  print:                            PropTypes.bool,
};

ResultViewer.defaultProps = {
  displayMhz: undefined,
  print: undefined
}

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ResultViewer)


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/ResultViewer.jsx